<div class="modal-container">
  <div class="modal-title">
    Atenci&oacute;n
  </div>
  <div class="modal-message mt-3">
    {{message}}

    <div *ngIf="step > 0" >
      <div class="row mt-3">
        <div class="col-lg">
          <form action=""  autocomplete="off">
            <div class="ccv">
              <input
                type="password"
                class="form-control"
                name="ccv" id="ccv"
                [(ngModel)]="flashController.controller.ccv"
                [appOnlyNumber]="true"
                maxlength="4"
                minlength="3"
                autocomplete="off"
                required="true"
              >
            </div>
          </form>

        </div>
      </div>
    </div>
  </div>

  <div class="row mt-4">
    <div class="col-lg mb-3">
      <div class="btn btn-danger btn-cancel padding-fix cancel-btn"  *ngIf="showCancel" (click)="cancel()">
        Cancelar
      </div>
    </div>
    <div class="col-lg">
      <div class="btn btn-danger padding-fix cancel-btn" *ngIf="step === 0" (click)="ok()">
        Aceptar
      </div>

      <div class="btn btn-danger padding-fix cancel-btn"  *ngIf="step > 0"  (click)="verifyProcess()">
        Aceptar
      </div>
    </div>
  </div>

  <!--
  <div class="action-container mt-4" [ngClass]="{'action-container-fix': !showCancel,'': showCancel}">
    <div class="btn btn-danger btn-cancel padding-fix cancel-btn"  *ngIf="showCancel" (click)="cancel()">
      Cancelar
    </div>

    <div class="btn btn-danger padding-fix cancel-btn" *ngIf="step === 0" (click)="ok()">
      Aceptar
    </div>

    <div class="btn btn-danger padding-fix cancel-btn"  *ngIf="step > 0"  (click)="verifyProcess()">
      Aceptar
    </div>


  </div>
  -->
</div>
